//
//
import { PropTypes } from 'prop-types';
import React from 'react';

import DatePicker from 'react-datepicker';


/**
 * CSS del plugin da riscrivere
 * 
 */
//import 'react-datepicker/dist/react-datepicker.css';

class DateField extends React.Component {
  constructor(props) {
    super(props);
    //
    this.state = {
      isDirty: false
    };
  }


  /**
   * Gestione gestione date passate da datepicker
   * 
   */
  handleDateChange = (date) => {
    this.props.onChange(this.props.fieldName, date);
  }

  /**
   * Gestione gestione date scritte manualmente in input field
   * 
   */
  handleDateChangeRaw = (event) => {
    this.props.onChange(this.props.fieldName, new Date(event.target.value));
  }

  handleBlur = (event) => {
    this.setState({ isDirty: true });
    //
    if (this.props.onBlur) {
      this.props.onBlur(this.props.fieldName);
    }
  }



  render() {


    const { fieldId, fieldName, fieldValue, disabled, locale, isClearable, isError, dateFormat } = this.props;
    const previousMonthButtonLabel = '';
    const nextMonthButtonLabel = '';
    return (
      <div className="datefield-wrapper">
        <DatePicker
          className={isError ? 'is-error' : ''} id={fieldId} name={fieldName} disabled={disabled} selected={fieldValue} onBlur={this.handleBlur} onChange={this.handleDateChange} onChangeRaw={this.handleDateChangeRaw} locale={locale} disabledKeyboardNavigation isClearable={isClearable} dateFormat={dateFormat}
          previousMonthButtonLabel={previousMonthButtonLabel}
          nextMonthButtonLabel={nextMonthButtonLabel}
        />
      </div>
    );
  }
}

DateField.defaultProps = {
  fieldId: null,
  fieldValue: null,
  disabled: false,
  locale: 'en',
  isClearable: true,
  isError: false,
  dateFormat: 'yyyy-MM-dd',
  onBlur: null

};

DateField.propTypes = {
  fieldId: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  fieldValue: PropTypes.object,
  disabled: PropTypes.bool,
  locale: PropTypes.string,
  isClearable: PropTypes.bool,
  isError: PropTypes.bool,
  dateFormat: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func

};

export default DateField;